import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var SidePopupService = /** @class */ (function () {
    function SidePopupService() {
        this.currentPopup = new Subject();
        this.currentPopupChanged$ = this.currentPopup.asObservable();
    }
    SidePopupService.prototype.createNewPopup = function (id) {
        this.currentPopup.next(id);
    };
    SidePopupService.prototype.removePopup = function () {
        this.currentPopup.next(null);
    };
    SidePopupService.ngInjectableDef = i0.defineInjectable({ factory: function SidePopupService_Factory() { return new SidePopupService(); }, token: SidePopupService, providedIn: "root" });
    return SidePopupService;
}());
export { SidePopupService };
